module.exports = __webpack_public_path__ + "img/car1.fae009a7.png";